import { type Translate, type TranslationKey } from '@/shared/i18n';

export const LIMITED_FEATURE_COPY_KEYS = {
  '1 Team space with up to 10 members': 'pricing.upgrade.bullets.1TeamSpaceWithUpTo10Members',
  '1 Team space with up to 5 members': 'pricing.upgrade.bullets.1TeamSpaceWithUpTo5Members',
  'about Lip-sync feature': 'pricing.upgrade.lipSync.aboutLipSyncFeature',
  'about SRT Download': 'pricing.upgrade.srtDownload.aboutSrtDownload',
  'about Teamspace collaboration': 'pricing.upgrade.teamspace.aboutTeamspaceCollaboration',
  'about Voice Clone library': 'pricing.upgrade.voicePresets.aboutVoiceCloneLibrary',
  'Add any terms with preferred translations (or mark as untranslated)':
    'pricing.upgrade.glossary.addAnyTermsWithPreferredTranslationsOrMark',
  'Adjust expressiveness or remove accents': 'pricing.upgrade.voicePresets.adjustExpressivenessOrRemoveAccents',
  'agencies and teams managing multiple dubbing projects without the chaos.':
    'pricing.upgrade.teamspace.agenciesAndTeamsManagingMultipleDubbingProjectsWithout',
  'AI script adjustment': 'pricing.upgrade.bullets.aiScriptAdjustment',
  'any content longer than a minute — tutorials, interviews, courses.':
    'pricing.upgrade.unlimitedLength.anyContentLongerThanAMinuteTutorialsInterviews',
  'anyone who publishes across platforms or works with a team.':
    'pricing.upgrade.subtitleExport.anyoneWhoPublishesAcrossPlatformsOrWorksWith',
  'API access': 'pricing.upgrade.bullets.apiAccess',
  'Apply to any project with one click': 'pricing.upgrade.glossary.applyToAnyProjectWithOneClick',
  'Automated captions/subtitles': 'pricing.upgrade.bullets.automatedCaptionsSubtitles',
  'Both original and translated subtitle versions with speakers':
    'pricing.upgrade.srtDownload.bothOriginalAndTranslatedSubtitleVersionsWithSpeakers',
  'brands and creators who need on-brand translations without heavy editing.':
    'pricing.upgrade.userPrompting.brandsAndCreatorsWhoNeedOnBrandTranslations',
  'Business contract and invoicing': 'pricing.upgrade.bullets.businessContractAndInvoicing',
  'Choose plan': 'pricing.upgrade.texts.choosePlan',
  'Collaborate with your team in one place.': 'pricing.upgrade.teamspace.collaborateWithYourTeamInOnePlace',
  'Contact us': 'pricing.upgrade.texts.contactUs',
  'Contact us to find the right number of Teamspaces and members for your team.':
    'pricing.upgrade.teamspace.contactUsToFindTheRightNumberOf',
  'Content that feels written for that audience, not translated':
    'pricing.upgrade.translationTone.contentThatFeelsWrittenForThatAudienceNot',
  'Control your translation': 'pricing.upgrade.userPrompting.controlYourTranslation',
  'Create a dictionary for your language pair': 'pricing.upgrade.glossary.createADictionaryForYourLanguagePair',
  'Creators dubbing in multiple languages and brands maintaining same voice across content.':
    'pricing.upgrade.voicePresets.creatorsDubbingInMultipleLanguagesAndBrandsMaintaining',
  'creators who need custom subtitle variations, YouTube uploads, or external editing workflows.':
    'pricing.upgrade.srtDownload.creatorsWhoNeedCustomSubtitleVariationsYoutubeUploads',
  'Custom price for minutes': 'pricing.upgrade.bullets.customPriceForMinutes',
  'Custom Voice Clone library': 'pricing.upgrade.bullets.customVoiceCloneLibrary',
  'Custom Voice Clone library (10 custom voices)': 'pricing.upgrade.bullets.customVoiceCloneLibrary10CustomVoices',
  'Dictionary saves your brand names, product terms, and key phrases — and uses them consistently across every project.':
    'pricing.upgrade.translationDictionary.dictionarySavesYourBrandNamesProductTermsAnd',
  'Download generated voice': 'pricing.upgrade.bullets.downloadGeneratedVoice',
  'Download generated voice with background sound': 'pricing.upgrade.bullets.downloadGeneratedVoiceWithBackgroundSound',
  'Download SRT → Send for corrections → Upload updated file':
    'pricing.upgrade.srtUpload.downloadSrtSendForCorrectionsUploadUpdatedFile',
  'Dub the whole video, not just a preview': 'pricing.upgrade.unlimitedLength.dubTheWholeVideoNotJustAPreview',
  'Enterprise users confirm translation edits up to 5× faster':
    'pricing.upgrade.userPrompting.enterpriseUsersConfirmTranslationEditsUpTo5',
  'Every face on screen, perfectly in sync': 'pricing.upgrade.lipSync.everyFaceOnScreenPerfectlyInSync',
  'Every word, every speaker, to the very end': 'pricing.upgrade.unlimitedLength.everyWordEverySpeakerToTheVeryEnd',
  'Everything in Business, plus:': 'pricing.upgrade.texts.everythingInBusinessPlus',
  'Everything in Creator Pro, plus:': 'pricing.upgrade.texts.everythingInCreatorProPlus',
  'Everything in Creator, plus:': 'pricing.upgrade.texts.everythingInCreatorPlus',
  'Everything in Trial, plus:': 'pricing.upgrade.texts.everythingInTrialPlus',
  'Export translated subtitles as an SRT file — already timed, already translated, ready to drop into any workflow.':
    'pricing.upgrade.subtitleExport.exportTranslatedSubtitlesAsAnSrtFileAlready',
  'Fix a term once, never correct it again': 'pricing.upgrade.translationDictionary.fixATermOnceNeverCorrectItAgain',
  'From 100 minutes every month': 'pricing.upgrade.bullets.from100MinutesEveryMonth',
  'From 2000 minutes every month': 'pricing.upgrade.bullets.from2000MinutesEveryMonth',
  'From 25 minutes every month': 'pricing.upgrade.bullets.from25MinutesEveryMonth',
  'From 500 minutes every month': 'pricing.upgrade.bullets.from500MinutesEveryMonth',
  'Get better translation control with Prompting and other Pro tools':
    'pricing.upgrade.translationTone.getBetterTranslationControlWithPromptingAndOther',
  'Get consistent translations with Dictionary and other Pro tools':
    'pricing.upgrade.translationDictionary.getConsistentTranslationsWithDictionaryAndOtherPro',
  'Get flexible subtitle files you can edit, customize, and use anywhere.':
    'pricing.upgrade.srtDownload.getFlexibleSubtitleFilesYouCanEditCustomize',
  'Get full control over your subtitles with SRT and Pro tools':
    'pricing.upgrade.srtDownload.getFullControlOverYourSubtitlesWithSrt',
  'Get full-length dubbing with other Pro tools':
    'pricing.upgrade.unlimitedLength.getFullLengthDubbingWithOtherProTools',
  'Get professional content with Lip-sync and other Pro tools':
    'pricing.upgrade.lipSync.getProfessionalContentWithLipSyncAndOther',
  'Get subtitle export with other Pro tools': 'pricing.upgrade.subtitleExport.getSubtitleExportWithOtherProTools',
  'Give full feature access for invitees without extra subscriptions':
    'pricing.upgrade.teamspace.giveFullFeatureAccessForInviteesWithoutExtra',
  'Guide word choice and terminology': 'pricing.upgrade.userPrompting.guideWordChoiceAndTerminology',
  'Hand off to editors or clients without extra steps':
    'pricing.upgrade.subtitleExport.handOffToEditorsOrClientsWithoutExtra',
  'How it works': 'pricing.upgrade.glossary.howItWorks',
  'how to use dictionary effectively': 'pricing.upgrade.glossary.howToUseDictionaryEffectively',
  'how to use prompting effectively': 'pricing.upgrade.userPrompting.howToUsePromptingEffectively',
  'how to use SRT upload': 'pricing.upgrade.srtUpload.howToUseSrtUpload',
  'Human-in-the-loop': 'pricing.upgrade.bullets.humanInTheLoop',
  'Instantly refresh text, timing, and speaker info':
    'pricing.upgrade.srtUpload.instantlyRefreshTextTimingAndSpeakerInfo',
  'Invite teammates with individual logins - no shared credentials':
    'pricing.upgrade.teamspace.inviteTeammatesWithIndividualLoginsNoSharedCredentials',
  'Learn more': 'pricing.upgrade.glossary.learnMore',
  'Less editing after every dub': 'pricing.upgrade.translationTone.lessEditingAfterEveryDub',
  'Level up dubbing with this and other Pro tools': 'pricing.upgrade.voicePresets.levelUpDubbingWithThisAndOtherPro',
  'Lip-sync matches mouth movements to translated audio so your video looks naturally dubbed, not overlaid.':
    'pricing.upgrade.lipSync.lipSyncMatchesMouthMovementsToTranslatedAudio',
  'Lock in translations once and they’ll stay consistent across all videos.':
    'pricing.upgrade.glossary.lockInTranslationsOnceAndTheyLlStay',
  'Looking to scale your team?': 'pricing.upgrade.teamspace.lookingToScaleYourTeam',
  'Make dubbed videos look natural by matching mouth movements to translated audio. Available on Creator Pro and above.':
    'pricing.upgrade.lipSync.makeDubbedVideosLookNaturalByMatchingMouth',
  'Make dubbed videos look real': 'pricing.upgrade.lipSync.makeDubbedVideosLookReal',
  'Make your cloned voice sound exactly right - every time.':
    'pricing.upgrade.voicePresets.makeYourClonedVoiceSoundExactlyRightEvery',
  'Make your dubbed videos match your brand voice.':
    'pricing.upgrade.userPrompting.makeYourDubbedVideosMatchYourBrandVoice',
  'Multispeaker Lip-Sync': 'pricing.upgrade.bullets.multispeakerLipSync',
  'Natural-looking dubbed videos in any language': 'pricing.upgrade.lipSync.naturalLookingDubbedVideosInAnyLanguage',
  'No content cut to fit a time limit': 'pricing.upgrade.unlimitedLength.noContentCutToFitATimeLimit',
  'No manual copy-paste': 'pricing.upgrade.srtUpload.noManualCopyPaste',
  'No more re-editing the same terms across projects':
    'pricing.upgrade.translationDictionary.noMoreReEditingTheSameTermsAcross',
  'No watermark': 'pricing.upgrade.bullets.noWatermark',
  'or Choose plan': 'pricing.upgrade.texts.orChoosePlan',
  'or Contact us': 'pricing.upgrade.teamspace.orContactUs',
  'or Upgrade to Business': 'pricing.upgrade.teamspace.orUpgradeToBusiness',
  'or Upgrade to Creator Pro': 'pricing.upgrade.srtDownload.orUpgradeToCreatorPro',
  'Perfect for': 'pricing.upgrade.glossary.perfectFor',
  'Personal Customer Manager': 'pricing.upgrade.bullets.personalCustomerManager',
  'Plain-text subtitle files with timecodes and spoken text':
    'pricing.upgrade.srtDownload.plainTextSubtitleFilesWithTimecodesAndSpoken',
  'professional content where visual authenticity matters.':
    'pricing.upgrade.lipSync.professionalContentWhereVisualAuthenticityMatters',
  'Publish to any market without losing credibility':
    'pricing.upgrade.lipSync.publishToAnyMarketWithoutLosingCredibility',
  'Publish to YouTube, TikTok, or any platform in minutes':
    'pricing.upgrade.subtitleExport.publishToYoutubeTiktokOrAnyPlatformIn',
  'Replace hours of manual editing with one click': 'pricing.upgrade.srtUpload.replaceHoursOfManualEditingWithOneClick',
  'Reuse your cloned voices across unlimited projects':
    'pricing.upgrade.voicePresets.reuseYourClonedVoicesAcrossUnlimitedProjects',
  'Save customized voice clones or create new ones from scratch':
    'pricing.upgrade.voicePresets.saveCustomizedVoiceClonesOrCreateNewOnes',
  'Scale your team': 'pricing.upgrade.teamspace.scaleYourTeam',
  'See plans with Dictionary': 'pricing.upgrade.translationDictionary.seePlansWithDictionary',
  'See plans with Lip-sync': 'pricing.upgrade.lipSync.seePlansWithLipSync',
  'See plans with Prompting': 'pricing.upgrade.translationTone.seePlansWithPrompting',
  'See plans with Subtitle export': 'pricing.upgrade.subtitleExport.seePlansWithSubtitleExport',
  'See plans with Unlimited length': 'pricing.upgrade.unlimitedLength.seePlansWithUnlimitedLength',
  'Set the tone, style, and context for translations with prompts. Pick from our templates or write your own prompt to fit your needs.':
    'pricing.upgrade.userPrompting.setTheToneStyleAndContextForTranslations',
  'Set tone and formality level': 'pricing.upgrade.userPrompting.setToneAndFormalityLevel',
  'Simultaneous multi-language translation': 'pricing.upgrade.bullets.simultaneousMultiLanguageTranslation',
  'SRT transcript upload and SRT download': 'pricing.upgrade.bullets.srtTranscriptUploadAndSrtDownload',
  'Synchronized lip movements with translated audio for multiple speakers':
    'pricing.upgrade.lipSync.synchronizedLipMovementsWithTranslatedAudioForMultiple',
  'Take your subtitles wherever the work happens':
    'pricing.upgrade.subtitleExport.takeYourSubtitlesWhereverTheWorkHappens',
  'teams and creators with specific terminology or brand language.':
    'pricing.upgrade.translationDictionary.teamsAndCreatorsWithSpecificTerminologyOrBrand',
  'Teams cut project coordination time by 60%': 'pricing.upgrade.teamspace.teamsCutProjectCoordinationTimeBy60',
  'teams who edit subtitles externally and want to sync updates fast.':
    'pricing.upgrade.srtUpload.teamsWhoEditSubtitlesExternallyAndWantTo',
  'teams with ongoing localization workflows.': 'pricing.upgrade.translationTone.teamsWithOngoingLocalizationWorkflows',
  'Tell us the tone, audience, and context — and get a translation that fits your content, not just the words.':
    'pricing.upgrade.translationTone.tellUsTheToneAudienceAndContextAnd',
  'Text segments formatted for video platforms or editing tools':
    'pricing.upgrade.srtDownload.textSegmentsFormattedForVideoPlatformsOrEditing',
  'Timestamps stay perfectly aligned with your video':
    'pricing.upgrade.subtitleExport.timestampsStayPerfectlyAlignedWithYourVideo',
  'Translation dictionaries': 'pricing.upgrade.bullets.translationDictionaries',
  'Translation prompting': 'pricing.upgrade.bullets.translationPrompting',
  'Translations that sound like you': 'pricing.upgrade.translationTone.translationsThatSoundLikeYou',
  'Translations that sound like you, not just correct':
    'pricing.upgrade.translationDictionary.translationsThatSoundLikeYouNotJustCorrect',
  'Trusted by 83% of Business users for translation accuracy':
    'pricing.upgrade.glossary.trustedBy83OfBusinessUsersForTranslation',
  'Unlimited Teamspaces and members': 'pricing.upgrade.bullets.unlimitedTeamspacesAndMembers',
  'Unlock .SRT download': 'pricing.upgrade.srtDownload.unlockSrtDownload',
  'Unlock AI rewrite feature': 'pricing.upgrade.aiRewrite.unlockAiRewriteFeature',
  'Unlock Audio download': 'pricing.upgrade.audioDownload.unlockAudioDownload',
  'Unlock Audio Export and more': 'pricing.upgrade.paywallTitles.unlockAudioExportAndMore',
  'Unlock Captions feature': 'pricing.upgrade.videoSubtitles.unlockCaptionsFeature',
  'Unlock Dictionary and more': 'pricing.upgrade.paywallTitles.unlockDictionaryAndMore',
  'Unlock Glossary and more': 'pricing.upgrade.paywallTitles.unlockGlossaryAndMore',
  'Unlock Lip-sync and more': 'pricing.upgrade.paywallTitles.unlockLipSyncAndMore',
  'Unlock Lip-sync feature': 'pricing.upgrade.lipSync.unlockLipSyncFeature',
  'Unlock more Voice Clones': 'pricing.upgrade.voicePresets.unlockMoreVoiceClones',
  'Unlock Multi-language and more': 'pricing.upgrade.paywallTitles.unlockMultiLanguageAndMore',
  'Unlock Multi-language translation feature': 'pricing.upgrade.multilanguage.unlockMultiLanguageTranslationFeature',
  'Unlock Prompting and more': 'pricing.upgrade.paywallTitles.unlockPromptingAndMore',
  'Unlock SRT Export and more': 'pricing.upgrade.paywallTitles.unlockSrtExportAndMore',
  'Unlock SRT upload': 'pricing.upgrade.srtUpload.unlockSrtUpload',
  'Unlock SRT Upload and more': 'pricing.upgrade.paywallTitles.unlockSrtUploadAndMore',
  'Unlock SRT upload feature': 'pricing.upgrade.srtUpload.unlockSrtUploadFeature',
  'Unlock Subtitle export and more': 'pricing.upgrade.paywallTitles.unlockSubtitleExportAndMore',
  'Unlock Teamspaces': 'pricing.upgrade.teamspace.unlockTeamspaces',
  'Unlock Teamspaces and more': 'pricing.upgrade.paywallTitles.unlockTeamspacesAndMore',
  'Unlock Translation dictionary': 'pricing.upgrade.glossary.unlockTranslationDictionary',
  'Unlock Translation prompting': 'pricing.upgrade.userPrompting.unlockTranslationPrompting',
  'Unlock Translation Prompting and more': 'pricing.upgrade.paywallTitles.unlockTranslationPromptingAndMore',
  'Unlock Translation prompting feature': 'pricing.upgrade.userPrompting.unlockTranslationPromptingFeature',
  'Unlock Unlimited Length and more': 'pricing.upgrade.paywallTitles.unlockUnlimitedLengthAndMore',
  'Unlock Video Subtitles and more': 'pricing.upgrade.paywallTitles.unlockVideoSubtitlesAndMore',
  'Unlock Voice Clone library': 'pricing.upgrade.voicePresets.unlockVoiceCloneLibrary',
  'Unlock Voice Presets and more': 'pricing.upgrade.paywallTitles.unlockVoicePresetsAndMore',
  'Up to unlimited Custom Voice Clones': 'pricing.upgrade.bullets.upToUnlimitedCustomVoiceClones',
  'Update subtitles in seconds': 'pricing.upgrade.srtUpload.updateSubtitlesInSeconds',
  'Upgrade to Business': 'pricing.upgrade.glossary.upgradeToBusiness',
  'Upgrade to Business for a Teamspace with 5 seats, or add the seats you need.':
    'pricing.upgrade.teamspace.upgradeToBusinessForATeamspaceWith5',
  'Upgrade to Business Plan': 'pricing.upgrade.texts.upgradeToBusinessPlan',
  'Upgrade to Business to create Translation Dictionary':
    'pricing.upgrade.glossary.upgradeToBusinessToCreateTranslationDictionary',
  'Upgrade to Business to save up to 10 Custom Voice Clones':
    'pricing.upgrade.voicePresets.upgradeToBusinessToSaveUpTo10',
  'Upgrade to Creator Plan': 'pricing.upgrade.texts.upgradeToCreatorPlan',
  'Upgrade to Creator Pro': 'pricing.upgrade.srtUpload.upgradeToCreatorPro',
  'Upgrade to Creator Pro Plan': 'pricing.upgrade.texts.upgradeToCreatorProPlan',
  'Upgrade to Creator Pro plan for speed control and AI-driven segment alignment to match your timestamps':
    'pricing.upgrade.aiRewrite.upgradeToCreatorProPlanForSpeedControl',
  'Upgrade to Creator Pro plan to add lip-sync to your videos and experience top-notch translation quality':
    'pricing.upgrade.lipSync.upgradeToCreatorProPlanToAddLip',
  'Upgrade to Creator Pro plan to download SRT files containing subtitles for both the original and translated videos':
    'pricing.upgrade.srtDownload.upgradeToCreatorProPlanToDownloadSrt',
  'Upgrade to Creator Pro plan to effortlessly pair your video with existing subtitles for accurate dubbing results':
    'pricing.upgrade.srtUpload.upgradeToCreatorProPlanToEffortlesslyPair',
  'Upgrade to Creator Pro to create a Сustom Voice Clone':
    'pricing.upgrade.voicePresets.upgradeToCreatorProToCreateAUstom',
  'Upgrade to Creator Pro to download videos with subtitles':
    'pricing.upgrade.videoSubtitles.upgradeToCreatorProToDownloadVideosWith',
  'Upgrade to Creator Pro to have Teamspace with up to 3 members':
    'pricing.upgrade.teamspace.upgradeToCreatorProToHaveTeamspaceWith',
  'Upgrade to Creator to download audio with generated voice or audio with voice and background sound':
    'pricing.upgrade.audioDownload.upgradeToCreatorToDownloadAudioWithGenerated',
  'Upgrade to Enterprise for custom Teamspaces and member limits, or add the seats you need.':
    'pricing.upgrade.teamspace.upgradeToEnterpriseForCustomTeamspacesAndMember',
  'Upgrade to Enterprise to save unlimited Custom Voice Clones':
    'pricing.upgrade.voicePresets.upgradeToEnterpriseToSaveUnlimitedCustomVoice',
  'Upload an edited SRT file': 'pricing.upgrade.srtUpload.uploadAnEditedSrtFile',
  'Upload corrected transcript in one click.': 'pricing.upgrade.srtUpload.uploadCorrectedTranscriptInOneClick',
  'Use ready-made templates or write custom prompts':
    'pricing.upgrade.userPrompting.useReadyMadeTemplatesOrWriteCustomPrompts',
  'videos with specific terminology and product names, or multilingual content libraries.':
    'pricing.upgrade.glossary.videosWithSpecificTerminologyAndProductNamesOr',
  'Voice Clone settings': 'pricing.upgrade.bullets.voiceCloneSettings',
  'What you can do': 'pricing.upgrade.voicePresets.whatYouCanDo',
  "What you'll get": 'pricing.upgrade.srtDownload.whatYouLlGet',
  'With Dictionary:': 'pricing.upgrade.translationDictionary.withDictionary',
  'With Lip-sync:': 'pricing.upgrade.lipSync.withLipSync',
  'With Prompting:': 'pricing.upgrade.translationTone.withPrompting',
  'With Subtitle export:': 'pricing.upgrade.subtitleExport.withSubtitleExport',
  "With the Business plan, you'll get:": 'pricing.upgrade.texts.withTheBusinessPlanYouLlGet',
  "With the Creator plan, you'll get:": 'pricing.upgrade.texts.withTheCreatorPlanYouLlGet',
  "With the Creator Pro plan, you'll get:": 'pricing.upgrade.texts.withTheCreatorProPlanYouLlGet',
  'With Unlimited length:': 'pricing.upgrade.unlimitedLength.withUnlimitedLength',
  'Work better together': 'pricing.upgrade.teamspace.workBetterTogether',
  'Work on shared projects seamlessly - no back and forth file transfers':
    'pricing.upgrade.teamspace.workOnSharedProjectsSeamlesslyNoBackAnd',
  "You've reached your free videos limit. Upgrade to Business plan to translate your videos into multiple languages":
    'pricing.upgrade.multilanguage.youVeReachedYourFreeVideosLimitUpgrade',
  'Your brand voice stays consistent in every language':
    'pricing.upgrade.translationDictionary.yourBrandVoiceStaysConsistentInEveryLanguage',
  'Your content feels native, not dubbed over': 'pricing.upgrade.lipSync.yourContentFeelsNativeNotDubbedOver',
  'Your full video, fully dubbed and ready to publish':
    'pricing.upgrade.unlimitedLength.yourFullVideoFullyDubbedAndReadyTo',
  'Your plan allows translation to 1 language per upload. Upgrade to translate your video into multiple languages':
    'pricing.upgrade.multilanguage.yourPlanAllowsTranslationTo1LanguagePer',
  'Your tone carries across every language': 'pricing.upgrade.translationTone.yourToneCarriesAcrossEveryLanguage',
  'Your trial previews 1 minute. On a paid plan, Rask dubs the entire file — nothing cut, nothing missing.':
    'pricing.upgrade.unlimitedLength.yourTrialPreviews1MinuteOnAPaid',
} as const satisfies Record<string, TranslationKey>;

const ENHANCED_LIP_SYNC_COPY =
  /^New Enhanced lip-sync model — studio-grade quality \(deducts (.+) minutes per 1 minute of video\)$/;
const MULTILANGUAGE_CAPTION_COPY = /^\(Learn more\)\[(.+)] how to effectively utilize this feature$/;

export function translateLimitedFeatureCopy(t: Translate, copy: string): string;
export function translateLimitedFeatureCopy(t: Translate, copy: undefined): undefined;
export function translateLimitedFeatureCopy(t: Translate, copy: string | undefined) {
  if (copy === undefined) return undefined;

  const translationKey = LIMITED_FEATURE_COPY_KEYS[copy as keyof typeof LIMITED_FEATURE_COPY_KEYS];
  if (translationKey) return t(translationKey);

  const enhancedLipSyncMatch = copy.match(ENHANCED_LIP_SYNC_COPY);
  if (enhancedLipSyncMatch) {
    return t('pricing.upgrade.lipSync.enhancedModel', { multiplier: enhancedLipSyncMatch[1] });
  }

  const multilanguageCaptionMatch = copy.match(MULTILANGUAGE_CAPTION_COPY);
  if (multilanguageCaptionMatch) {
    return t('pricing.upgrade.multilanguage.learnMoreCaption', { link: multilanguageCaptionMatch[1] });
  }

  return copy;
}
